<template>
  <div class="signing">
    <div id="canvasBox" v-bind:style="getHorizontalStyle">
      <div class="greet">
        <span>{{ msg }}</span>
      </div>
      <canvas
        style="width:90%;height:80%;border:2px dashed #ccc;border-radius:32px;background:#eee;"
      ></canvas>
      <div>
        <button type="button" class="reset-sign" @click="clear">重新签字</button>
        <button type="button" class="success-sign" @click="savePNG">完成</button>
      </div>
    </div>
  </div>
</template>
<script>
import { Draw } from "@/common/draw.js";
export default {
  name: "signing",
  data() {
    return {
      msg: "请在虚线内签名，如签名异常，请关闭手机自动旋转屏幕后再签名",
      degree: 90,
      signImage: null,
      draw: null,
      signData: {},
      childData: {}
    };
  },
  created() {},
  mounted() {
    this.signData = this.$store.state.parentInfo.signData;
    this.childData = this.$store.state.parentInfo.childData;
    this.canvasBox = document.getElementById("canvasBox");
    this.initCanvas();
  },
  beforeCreate() {
    document.title = "手写签名";
  },
  computed: {
    getHorizontalStyle() {
      const d = document;
      const w =
        window.innerWidth ||
        d.documentElement.clientWidth ||
        d.body.clientWidth;
      const h =
        window.innerHeight ||
        d.documentElement.clientHeight ||
        d.body.clientHeight;
      let length = (h - w) / 2;
      let width = w;
      let height = h;
      switch (this.degree) {
        case -90:
          length = -length;
          break;
        case 90:
          width = h;
          height = w;
          break;
        default:
          length = 0;
      }
      if (this.canvasBox) {
        this.canvasBox.removeChild(document.querySelector("canvas"));
        this.canvasBox.appendChild(document.createElement("canvas"));
        this.initCanvas();
        // setTimeout(() => {
        //   this.initCanvas()
        // },200)
      }
      return {
        transform: `rotate(${this.degree}deg) translate(${length}px,${length}px)`,
        width: `${width}px`,
        height: `${height}px`,
        transformOrigin: "center center"
      };
    }
  },
  methods: {
    initCanvas() {
      const canvas = document.querySelector("canvas");
      this.draw = new Draw(canvas, -this.degree);
    },
    clear() {
      this.draw.clear();
    },
    getBlob: function(dataURI) {
      //获取blob对象
      //return new Blob([ia], { type: mimeString });
      var data = dataURI.toDataURL("image/png", 1);
      var datas = data.split(",")[1];
      var byteString = window.atob(datas);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {
        type: "image/png"
      });
    },
    async savePNG() {
      this.signImage = this.draw.getJPGImage();
      if (this.signImage) {
        const canvas = document.querySelector("canvas");
        let blob = this.getBlob(canvas);
        //生成formData
        let oMyForm = new FormData();
        let fileName = "sign" + ".png";
        oMyForm.append("file", blob, fileName);
        oMyForm.append("fileType", "image");
        this.xy.loading();
        let postUrl = `${this.$store.state.apiPath}/api/SignFileDetailManage/UploadSignPic?SignFileID=${this.signData.SignFileID}&StudentID=${this.childData.ChildrenID}`;
        let res = await this.xyapi.post(postUrl, oMyForm);
        if (res.success) {
          this.$router.push("/homeSchool/FileSign");
          this.xy.msgSuc("签字完成");
        }
        this.xy.unloading();
      }
    },
    upload() {
      const image = this.draw.getPNGImage();
      const blob = this.draw.dataURLtoBlob(image);
      const url = "";
      const successCallback = response => {
        console.log(response);
      };
      const failureCallback = error => {
        console.log(error);
      };
      this.draw.upload(blob, url, successCallback, failureCallback);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#canvasBox {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.greet {
  padding: 0 0 20px;
  font-size: 28px;
  user-select: none;
}

input {
  font-size: 28px;
}

.greet select {
  font-size: 32px;
}

canvas {
  flex: 1;
  cursor: crosshair;
  border: 2px dashed lightgray;
}

.image-box {
  width: 100%;
  height: 100%;
}

.image-box header {
  font-size: 32px;
}

.image-box img {
  max-width: 80%;
  max-height: 80%;
  margin-top: 100px;
  border: 2px solid gray;
}
.reset-sign {
  border: none;
  border-radius: 40px;
  background: #ddd;
  color: #7f7f7f;
  padding: 10px 20px;
  margin-top: 10px;
  margin-left: 50px;
}
.success-sign {
  border: none;
  border-radius: 40px;
  background: #4196ff;
  color: #fff;
  padding: 10px 20px;
  width: 150px;
  margin-left: 50px;
}
</style>
